import { render, staticRenderFns } from "./BarChartHorizontal.vue?vue&type=template&id=1c689614&"
import script from "./BarChartHorizontal.vue?vue&type=script&lang=js&"
export * from "./BarChartHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c689614')) {
      api.createRecord('1c689614', component.options)
    } else {
      api.reload('1c689614', component.options)
    }
    module.hot.accept("./BarChartHorizontal.vue?vue&type=template&id=1c689614&", function () {
      api.rerender('1c689614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Widgets/BarChartHorizontal.vue"
export default component.exports